import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { GraphExpense, GraphExpenseState } from "@/types/chart";
import { GetExpense } from "@/types/expense";

const initialState: GraphExpenseState = {
  sortedByCategory: [],
  sortedByBranch: [],
  expensesForGraph: [],
};

export const graphSlice = createSlice({
  name: "graph",
  initialState,
  reducers: {
    orderByCategory: (state, action: PayloadAction<GraphExpense>) => {
      state.sortedByCategory = [action.payload];
    },
    orderByBranch: (state, action: PayloadAction<GraphExpense>) => {
      state.sortedByBranch = [action.payload];
    },
    allExpenses: (state, action: PayloadAction<GetExpense[]>) => {
      state.expensesForGraph = action.payload;
    },
  },
});

export const { orderByBranch, orderByCategory, allExpenses } =
  graphSlice.actions;

export default graphSlice.reducer;
